import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GasStationService } from 'src/app/service/gas-station/gas-station.service';
import { GasStation } from 'src/app/domain/gas-station';
import Swal from 'sweetalert2';
import { ViaCep } from 'src/app/domain/viacep';
import { State } from 'src/app/domain/state';
import { City } from 'src/app/domain/city';
import { AddressService } from 'src/app/service/address/address.service';
import { UtilsService } from 'src/app/service/utils/utils.service';
import { Address } from 'src/app/domain/address';
import { Router } from '@angular/router';
import { Validations } from '../../validations';
import { TimeoutError } from 'rxjs';

@Component({
  selector: 'app-gas-station-create',
  templateUrl: './gas-station-create.component.html',
  styleUrls: ['./gas-station-create.component.css'],
})
export class GasStationCreateComponent implements OnInit {
  gasStationForm: FormGroup;
  loading: boolean = false;
  messageError: string = '';
  viacep: ViaCep = new ViaCep();
  states: Array<State> = [];
  cities: Array<City> = [];

  constructor(
    private service: GasStationService,
    private serviceAddress: AddressService,
    private utilsService: UtilsService,
    private fb: FormBuilder,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.serviceAddress.getStates().subscribe(
      (data) => {
        this.states = data;
      },
      (error) => {
        Swal.fire('Erro', 'Não foi possível Buscar os Estados!', 'error');
      }
    );
  }

  createForm() {
    this.gasStationForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(60)]],
      email: ['', [Validators.maxLength(80), Validators.email]],
      phone: ['', [Validations.validPhone]],
      whatsapp: ['', [Validations.validwhatsapp]],
      contact: ['', [Validators.maxLength(100)]],
      zipCode: ['', [Validators.required, Validators.maxLength(9)]],
      publicPlace: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
    });
  }
  onBlurCep(event) {
    // event.target.value
    this.loading = true;

    if (event.target.value.replace(/[^0-9,.]+/g, '').length === 8) {
      this.utilsService
        .getCep(event.target.value.replace(/[^0-9,.]+/g, ''))
        .subscribe(
          (data) => {
            this.viacep = data;

            if (!this.viacep.erro) {
              this.gasStationForm.controls.neighborhood.setValue(
                this.viacep.bairro
              );
              this.gasStationForm.controls.publicPlace.setValue(
                this.viacep.logradouro
              );
              const state = this.states.find(
                (state) => state.initials === this.viacep.uf.toUpperCase()
              );

              this.gasStationForm.controls.state.setValue(state.id);

              // TODO - Implementar busca de cidades por UF
              this.serviceAddress.getCitiesByStateId(state.id).subscribe(
                (data) => {
                  this.cities = data;
                  const city = this.cities.find(
                    (elem) =>
                      elem.name.normalize('NFD') ===
                      this.viacep.localidade
                        .toUpperCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                  );
                  if (city) {
                    this.gasStationForm.controls.city.setValue(city.id);
                  }
                },
                (error) => {
                  Swal.fire(
                    'Erro ao salvar',
                    'Erro ao buscar cidades!',
                    'error'
                  );
                }
              );
            } else {
              this.gasStationForm.controls.zipCode.setErrors({
                invalid: 'CEP não encontrado!',
              });
            }
            this.loading = false;
          },
          (err) => {
            if (err instanceof TimeoutError) {
              Swal.fire({
                title: 'Erro ao buscar os dados do endereço!',
                text: 'O Servidor de busca de endereços não respondeu!\nPor favor, preencha os dados de endereço manualmente.',
                icon: 'error',
                toast: false,
              });
              this.loading = false;
              return;
            }
            this.gasStationForm.controls.zipCode.setErrors({
              invalid: 'CEP não encontrado!',
            });
            this.loading = false;
          }
        );
    } else {
      this.loading = false;
      this.gasStationForm.controls.zipCode.setErrors({
        invalid: 'CEP inválido!',
      });
    }
  }

  onSelectedState(event) {
    // TODO - Ao selecionar um estado no formulário de busca ir no servidor e buscar as cidades relacionadas ao estado
    if (event.target.value) {
      this.loading = true;
      this.serviceAddress.getCitiesByStateId(event.target.value).subscribe(
        (data) => {
          this.cities = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          Swal.fire('Ops', 'Erro ao buscar cidades!', 'error');
        }
      );
    }
  }

  onSubmit() {
    if (!this.loading) {
      try {
        this.loading = true;
        const values = this.gasStationForm.controls;

        let gasStation = new GasStation();
        gasStation.address = new Address();
        gasStation.address.city = new City();
        gasStation.name = this.gasStationForm.controls.name.value;
        gasStation.email = this.gasStationForm.controls.email.value;
        gasStation.phone = this.gasStationForm.controls.phone.value;
        gasStation.whatsapp = this.gasStationForm.controls.whatsapp.value;
        gasStation.contact = this.gasStationForm.controls.contact.value;
        gasStation.address.zipCode =
          this.gasStationForm.controls.zipCode.value.replace(/[^0-9,.]+/g, '');
        gasStation.address.neighborhood =
          this.gasStationForm.controls.neighborhood.value;
        gasStation.address.publicPlace =
          this.gasStationForm.controls.publicPlace.value;
        gasStation.address.city.id = Number(
          this.gasStationForm.controls.city.value
        );

        this.service.save(gasStation).subscribe(
          (data) => {
            this.loading = false;
            Swal.fire(
              'Salvo',
              'Posto de Combustível salvo com sucesso!!',
              'success'
            ).then((result) => {
              if (result.value) {
                this.router.navigate(['parameters/gas-station']);
              }
            });
            this.createForm();
          },
          (error) => {
            console.log(error);
            this.loading = false;
            this.setErrors(error.error.errors);
            Swal.fire(
              'Erro ao salvar',
              'Não foi possível salvar Posto de Combustível!',
              'error'
            );
          }
        );
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    }
  }

  resetForm() {
    this.gasStationForm.controls.name.setValue('');
    this.gasStationForm.controls.email.setValue('');
    this.gasStationForm.controls.phone.setValue('');
    this.gasStationForm.controls.whatsapp.setValue('');
    this.gasStationForm.controls.contact.setValue('');
    this.gasStationForm.controls.zipCode.setValue('');
    this.gasStationForm.controls.neighborhood.setValue('');
    this.gasStationForm.controls.publicPlace.setValue('');
    this.gasStationForm.controls.state.setValue('');
    this.gasStationForm.controls.city.setValue('');
  }

  setErrors(errors) {
    errors.forEach((erro) => {
      switch (erro.fieldName) {
        case 'name':
          this.gasStationForm.controls.name.setErrors({
            invalid: erro.message,
          });
          break;
        case 'email':
          this.gasStationForm.controls.email.setErrors({
            invalid: erro.message,
          });
          break;
        case 'phone':
          this.gasStationForm.controls.phone.setErrors({
            invalid: erro.message,
          });
          break;
        case 'whatsapp':
          this.gasStationForm.controls.email.setErrors({
            invalid: erro.message,
          });
          break;
        case 'contact':
          this.gasStationForm.controls.contact.setErrors({
            invalid: erro.message,
          });
          break;
        case 'zipCode':
          this.gasStationForm.controls.zipCode.setErrors({
            invalid: erro.message,
          });
          break;
        case 'neighborhood':
          this.gasStationForm.controls.neighborhood.setErrors({
            invalid: erro.message,
          });
          break;
        case 'publicPlace':
          this.gasStationForm.controls.publicPlace.setErrors({
            invalid: erro.message,
          });
          break;
        case 'state':
          this.gasStationForm.controls.state.setErrors({
            invalid: erro.message,
          });
          break;
        case 'city':
          this.gasStationForm.controls.city.setErrors({
            invalid: erro.message,
          });
          break;
        default:
          this.messageError += `${erro.message}\n`;
      }
    });
  }
}
